import axios from "axios";
import { API_URL } from "@/helpers";

export const subscriptionService = {
  createCard,
  deleteCard,
  getPlans,
  retrieveSubscription,
  createSubscription,
  updateSubscription,
  cancelSubscription,
  retrieveCoupon
};

export function createCard(token) {
  return axios.post(`${API_URL}/1/subscriptions/card/`, token);
}

export function deleteCard() {
  return axios.delete(`${API_URL}/1/subscriptions/card/delete/`);
}

export function getPlans() {
  return axios.get(`${API_URL}/1/subscriptions/plans/`);
}

export function retrieveSubscription() {
  return axios.get(`${API_URL}/1/subscriptions/`);
}

export function createSubscription(subscription) {
  return axios.post(`${API_URL}/1/subscriptions/create/`, subscription);
}

export function updateSubscription(subscription) {
  return axios.put(`${API_URL}/1/subscriptions/update/`, subscription);
}

export function cancelSubscription() {
  return axios.delete(`${API_URL}/1/subscriptions/cancel/`);
}

export function retrieveCoupon(coupon) {
  return axios.get(
    `${API_URL}/1/subscriptions/coupon/${coupon.term}/${coupon.code}/`
  );
}
